'use client';

import { c as _c } from "react/compiler-runtime";
import { TileCard } from './TileCard';
import { TileVideo } from './ui/tile-video';
interface BricksTileProps {
  className?: string;
  onClick?: () => void;
}
export default function BricksTile(t0) {
  const $ = _c(4);
  const {
    className,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TileVideo src="/images/craft/bricks-optimized.mp4" posterSrc="/images/craft/bricks-poster.jpg" title="Bricks" className="size-full object-cover transition-transform group-hover:scale-105" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== onClick) {
    t2 = <TileCard href="/bricks" title="Bricks" description="Famous machines and minds as brick sets, with instructions." className={className} onClick={onClick}>{t1}</TileCard>;
    $[1] = className;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}